import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {  useState } from "react";
import styles from "./HeaderDashboard.module.css";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import user from "../../assets/user-d.png";
import { useNavigate } from "react-router-dom";
import { GetAuth, LogOut } from "../../helpers/Auth";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { toast } from "react-toastify";
import { DialogCloseSession } from "../DialogCloseSession/DialogCloseSesion";

const HeaderDashboard = (props) => {
  const navigate = useNavigate();
  const [userImage, setUserImage] = useState(user);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewProfile = () => {
    navigate("/cuenta");
    handleClose();
  };

  const handleLogout = () => {
    LogOut();
    setTimeout(() => {
      navigate("/login", { replace: true });
      toast("Ha cerrado sesión satisfactoriamente", { type: "info" });
    }, 0);
  };

  const logoutOption = () => {
    setOpenDialog(true);
  };

  const stay = () => {
    setOpenDialog(false);
  };

  return (
    <div className={styles.headerDashboard}>
      <div>
        <FontAwesomeIcon
          style={{
            width: "25px",
            height: "25px",
            color: "#787878",
            cursor: "pointer",
          }}
          onClick={props.handlerClick.hideMenu}
          icon={faBars}
        />
      </div>
      <div>
        <div className="user-image">
          <div className="user-image-box">
            <IconButton onClick={handleClick}>
              <img
                src={userImage}
                alt="User Avatar"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src = user;
                }}
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
            </IconButton>
          </div>
        </div>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleViewProfile}>Ver perfil</MenuItem>
          <MenuItem onClick={logoutOption}>Cerrar sesión</MenuItem>
        </Menu>
      </div>
      <DialogCloseSession
        open={openDialog}
        setOpen={setOpenDialog}
        onConfirm={handleLogout}
        onCancel={stay}
      />
    </div>
  );
};

export default HeaderDashboard;
